import styled from 'styled-components';
import { colors } from '../../../defaultTheme';
const Input = styled.input `
  margin-right: 12px;
  font-size: ${({ fontSize }) => fontSize}px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border: solid 2px
    ${({ hasError, value }) => {
    if (hasError) {
        return colors.error;
    }
    if (value) {
        return colors.cyanBlue;
    }
    return colors.mediumGrey;
}};
  text-align: center;
  border-radius: 6px;
  &:focus {
    border: solid 3px ${colors.cyanBlue};
    outline: solid 3px ${colors.brightBlue};
  }
  &:last-child {
    margin-right: 0px;
  }
`;
export default Input;
//# sourceMappingURL=subcomponents.js.map